export default __webpack_public_path__ + "static/media/wwf_main.96d9afe4.jpg";